import React, { useEffect, useState } from 'react';
import './team-view.styles.scss';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getQueryFromFirestore } from '@/utils/getDataFromDbSimplified';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component';
import { sortPlayers } from '@/utils/sortPlayers';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { completePlayerData } from '@/components/PREVIEW/previewPlayers';
import TeamViewContent from './team-view-content.component';

const TeamView = ({
  gameData,
  playerList,
}) => {

  const { teamPath } = useParams();
  const [teamData, setTeamData] = useState(null);
  const [ teamMemberList, setTeamMemberList ] = useState([]);
  const [ totalTeamPlayerPoints, setTotalTeamPlayerPoints ] = useState(0);
  const [ teamEarnedPoints, setTeamEarnedPoints ] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  let teamListener;

  useEffect(() => {

    return () => {
      if (teamListener) teamListener();
    }
  }, [])

  useEffect(() => {
    if (!teamPath || !gameData) return;
    console.log(teamPath);
    getTeamData();
  }, [teamPath, gameData])

  

  function getTeamData() {
    if (location.pathname.includes('/preview/manager/')) {
      const teamInfo = Object.values(completePlayerData)
        .find(p => p.path === teamPath);
      setTeamData(teamInfo);
      return;
    }
    getQueryFromFirestore({
      'path': `games/${gameData.gameId}/players/`,
      'queryArray': [{
        'field': 'path',
        'operator': '==',
        'value': teamPath
      }],
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      console.log(data);
      setTeamData(data);
    }
    function handleListener(unsub) {
      teamListener = unsub;
    }
  }

  return (
    <div className='team-view-container'>
      {
        teamData &&
        <TeamViewContent
          gameData={gameData}
          teamData={teamData}
          playerList={playerList} />
      }
    </div>
  )
}

export default TeamView